<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <md-icon>people</md-icon>
          </div>
          <p class="category">Total Application / Net User</p>
          <h3 class="title">
            {{ total_application }} /
            {{ net_student }}
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Just Updated
          </div>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="rose">
        <template slot="header">
          <div class="card-icon">
            <md-icon>account_balance</md-icon>
          </div>
          <p class="category">Offer Send Student</p>
          <h3 class="title">
            {{ offer_send_student }}
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Just Updated
          </div>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>list_alt</md-icon>
          </div>
          <p class="category">Accepted Student</p>
          <h3 class="title">
            {{ accepted_student }}
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>update</md-icon>
            Just Updated
          </div>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="warning">
        <template slot="header">
          <div class="card-icon">
            <md-icon>night_shelter</md-icon>
          </div>
          <p class="category">Registered Student</p>
          <h3 class="title">
            {{ registered_count }}
          </h3>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>date_range</md-icon>
            Last <animated-number :value="24"></animated-number> Hours
          </div>
        </template>
      </stats-card>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <chart-card
        header-animation="true"
        :chart-data="applicationChart.data"
        :chart-options="applicationChart.options"
        :chart-responsive-options="applicationChart.responsiveOptions"
        chart-type="Bar"
        chart-inside-header
        background-color="rose"
        ref="applicationChartRef"
      >
        <md-icon slot="fixed-button">build</md-icon>
        <md-button class="md-simple md-info md-just-icon" slot="first-button">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Daily Applications</h4>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            updated <animated-number :value="10"></animated-number> days ago
          </div>
        </template>
      </chart-card>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <chart-card
        :chart-data="acceptanceChart.data"
        :chart-options="acceptanceChart.options"
        chart-type="Line"
        chart-inside-header
        background-color="blue"
        ref="acceptanceChartRef"
      >
        <md-button class="md-simple md-info md-just-icon" slot="first-button">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Daily Acceptance</h4>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            campaign sent
            <animated-number :value="26"></animated-number> minutes ago
          </div>
        </template>
      </chart-card>
    </div>
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
    >
      <chart-card
        :chart-data="registeredChart.data"
        :chart-options="registeredChart.options"
        chart-type="Line"
        chart-inside-header
        background-color="green"
        ref="registeredChartRef"
      >
        <md-button class="md-simple md-info md-just-icon" slot="first-button">
          <md-icon>refresh</md-icon>
          <md-tooltip md-direction="bottom">Refresh</md-tooltip>
        </md-button>

        <template slot="content">
          <h4 class="title">Daily Registered</h4>
        </template>

        <template slot="footer">
          <div class="stats">
            <md-icon>access_time</md-icon>
            updated <animated-number :value="4"></animated-number> minutes ago
          </div>
        </template>
      </chart-card>
    </div>
    <div class="md-layout-item md-size-100 announcements">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">Universities Announcements</h4>
            <p class="category">Announcements For All Universities</p>
          </div>
        </md-card-header>
        <md-card-content>
          <md-table
            v-model="announcements"
            class="table-shopping"
            style="max-height: 400px"
          >
            <md-table-empty-state
              md-label="No announcements found"
              :md-description="`No announcements found for now.`"
            >
            </md-table-empty-state>
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              md-auto-select
            >
              <md-table-cell v-if="item.university">
                {{ item.university.name }}
              </md-table-cell>
              <md-table-cell v-else>
                General
              </md-table-cell>
              <md-table-cell class="td-name">
                <a>{{ item.title }}</a>
                <br />
                <small>{{ item.content }}</small>
              </md-table-cell>
              <md-table-cell>
                {{ item.created_date }}
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { StatsCard, ChartCard, AnimatedNumber } from "@/components";

export default {
  components: {
    StatsCard,
    ChartCard,
    AnimatedNumber
  },
  data() {
    return {
      announcements: [],
      total_application: 0,
      net_student: 0,
      offer_send_student: 0,
      accepted_student: 0,
      registered_count: 0,

      application_keys: [],
      application_values: [],
      acceptance_keys: [],
      acceptance_values: [],
      registered_keys: [],
      registered_values: [],

      product1: "/img/card-2.jpg",
      product2: "/img/card-3.jpg",
      product3: "/img/card-1.jpg",
      seq2: 0,
      mapData: {
        AU: 760,
        BR: 550,
        CA: 120,
        DE: 1300,
        FR: 540,
        GB: 690,
        GE: 200,
        IN: 200,
        RO: 600,
        RU: 300,
        US: 2920
      },
      registeredChart: {
        data: {
          labels: [],
          series: []
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 10, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      acceptanceChart: {
        data: {
          labels: [],
          series: []
        },

        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 15, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      applicationChart: {
        data: {
          labels: [],
          series: []
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 40,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      },
      dates: []
    };
  },
  methods: {
    createDates() {
      var X = 7;
      for (let I = 0; I < Math.abs(X); I++) {
        this.dates.push(
          new Date(
            new Date().getTime() -
              (X >= 0 ? I : I - I - I) * 24 * 60 * 60 * 1000
          )
            .toLocaleDateString("ko-KR")
            .replaceAll(". ", "-")
            .replaceAll(".", "")
        );
      }
      this.dates.reverse();
    },
    createValues(data) {
      var items = {};
      for (const date in this.dates) {
        items[this.dates[date]] = 0;
        for (const values in data) {
          let data_date = data[values]["date"].replaceAll("-0", "-");
          if (data_date === this.dates[date]) {
            items[this.dates[date]] = data[values]["count"];
            break;
          }
        }
      }
      return [Object.values(items)];
    },
    getAnnouncements() {
      this.$store
        .getUniversityAnnouncements({ limit: 15 })
        .then(response => {
          this.announcements = response.data.results;
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 3000
          });
        });
    }
  },
  mounted() {
    this.$store
      .getGeneralInformation()
      .then(response => {
        this.total_application = response.data.total_application;
        this.net_student = response.data.net_student;
        this.offer_send_student = response.data.offer_send_student;
        this.accepted_student = response.data.accepted_student;
        this.registered_count = response.data.registered_count;
      })
      .catch(error => {
        var message = error.response.data;
        this.$notify({
          message: JSON.stringify(message),
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top",
          timeout: 3000
        });
      });
    this.createDates();
    this.$store
      .getGeneralInformationForChart()
      .then(response => {
        this.applicationChart.data.labels = this.dates;
        this.applicationChart.data.series = this.createValues(
          response.data.total_application
        );
        import("chartist").then(Chartist => {
          let ChartistLib = Chartist.default || Chartist;
          this.$nextTick(() => {
            this.$refs["applicationChartRef"].initChart(ChartistLib);
          });
        });

        this.acceptanceChart.data.labels = this.dates;
        this.acceptanceChart.data.series = this.createValues(
          response.data.acceptance
        );
        import("chartist").then(Chartist => {
          let ChartistLib = Chartist.default || Chartist;
          this.$nextTick(() => {
            this.$refs["acceptanceChartRef"].initChart(ChartistLib);
          });
        });

        this.registeredChart.data.labels = this.dates;
        this.registeredChart.data.series = this.createValues(
          response.data.registered
        );
        import("chartist").then(Chartist => {
          let ChartistLib = Chartist.default || Chartist;
          this.$nextTick(() => {
            this.$refs["registeredChartRef"].initChart(ChartistLib);
          });
        });
      })
      .catch(error => {
        var message = error.response.data;
        this.$notify({
          message: JSON.stringify(message),
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top",
          timeout: 3000
        });
      });
    this.getAnnouncements();
  }
};
</script>

<style>
body
  > div
  > div.main-panel
  > div.content
  > div
  > div.md-layout-item.md-size-100.announcements
  > div
  > div.md-card-content
  > div
  > div
  > table
  > thead {
  display: none;
}
</style>
